<template>
    <div id="reportCancelClass">
        <card>
            <Form ref="searchForm" :model="searchForm" inline class="searchForm" id="searchFormSection" @keyup.enter.native="getData()">
                <Form-item prop="zoneId" label="校区" :label-width="60">
                    <Select v-model="searchForm.zoneId" filterable style="width: 250px" placeholder="全部" clearable>
                        <Option v-for="item in zoneList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                    </Select>
                </Form-item>
                <FormItem prop="daterange" label="时间范围" :label-width="120">
                    <DatePicker :value="searchForm.daterange" type="daterange" split-panels placeholder="选择时间范围"
                                style="width: 240px"
                                format="yyyy-MM-dd" @on-change="searchForm.daterange=$event"></DatePicker>
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="getDate"  size="small" style="margin-right:10px;">搜索</Button>
                    <Button type="primary" @click="exportDate"  size="small">导出</Button>
                </FormItem>
            </Form>
            <Table :columns="columns" :data="data">
                <div slot="header" style="text-align: left" >
                    <div v-if="summary.total > 0" style="font-size: 16px;font-weight: bold;margin-left:15px; ">
                        共取消{{summary.total}}次，其中学员请假{{summary.bystudent}}次
                    </div>
                </div>
                <template slot-scope="{ row, index }" slot="action">
                    <Button @click="showDetail(row.day)" type="info" size="small" style="margin-right: 5px">明细</Button>
                </template>
            </Table>
        </card>
        <Modal v-model="showdetailModal" title="请假清单"  width="1000">
            <Table :columns="detailColumns" :data="detailData"></Table>
            <div slot="footer"></div>
        </Modal>
    </div>
</template>
<script>
  import moment from 'moment';
  import config from '@/config'
  const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

  export default {
    name: 'report_cancel_class',
    data () {
      return {
        total:0,
        searchForm:{
          daterange: [
            moment(new Date()).startOf("month").format("YYYY-MM-DD"),
            moment(new Date()).endOf("month").format("YYYY-MM-DD")
          ],
          zoneId:this.$store.state.app.zoneList[0].id
        },
        columns: [
          {
            title: '日期',
            key: 'day'
          },
          {
            title: '取消课程总数',
            key: 'total',
            align:'center'
          },
          {
            title: '学员请假数',
            key: 'bystudent',
            align:'center'
          },
          {
            title: '操作',
            slot: 'action'
          }
        ],
        data: [],
        summary:{},
        detailColumns:[
          {
            title: '校区',
            key: 'zone'
          },
          {
            title: '教师',
            key: 'student'
          },
          {
            title: '班级',
            key: 'clazz'
          },
          {
            title: '学员',
            key: 'student'
          },
          {
            title: '请假时间',
            key: 'optime'
          },
          {
            title: '请假课程',
            key: 'course'
          },
          {
            title: '请假原因',
            key: 'reason'
          },
          {
            title: '类型',
            key: 'type'
          },
        ],
        detailData:[],
        showdetailModal:false
      }
    },
    computed: {
      zoneList() {
        return this.$store.state.app.zoneList
      },
    },
    methods: {
      getDate(){
        this.$api.report.cancelclass({
          startDate:this.searchForm.daterange[0],
          endDate:this.searchForm.daterange[1],
          zoneId:this.searchForm.zoneId
        }).then(resp => {
          this.data = resp.list;
          this.summary = resp.summary;
        });
      },
      showDetail(day){
        this.detailData = [];
        this.$api.report.cancelclassdetail({
          startDate:day,
          endDate:day,
          zoneId:this.searchForm.zoneId
        }).then(res => {
          if (res.state == "ok") {
            this.detailData = res.list;
            this.showdetailModal = true;
          } else {
            this.$Message.error(res.msg)
          }
        });

      },
      exportDate(){
        window.open(baseUrl+"edu/web/report/exportcancelclass?startDate="
          +this.searchForm.daterange[0]+"&endDate="+this.searchForm.daterange[1]
          +"&zoneId="+this.searchForm.zoneId);
      }
    },
    mounted: function () {
      this.getDate();
    }
  }
</script>
